export class SvgInjector {
    init()
    {

        var self = this;

        var mySVGsToInject = document.querySelectorAll('img.inject-svg');
        SVGInjector(mySVGsToInject, {}, function ()
        {
        	if($('#map').length != 0){
            	$('#map').consultantMap();
        	}
        });
    }
}
